"use client";

const gtmProperties = {};

export const registerGtmProperties = (props) => {
	Object.assign(gtmProperties, props);
};

export const pushGtmEvent = (eventName, props) => {
	if (typeof window !== "undefined" && typeof window.dataLayer !== "undefined") {
		const data = {
			event: eventName,
			environment: process.env.NEXT_PUBLIC_STAGE,
			...gtmProperties,
			...props,
		};

		console.log("pushGtmEvent", { data });
		window.dataLayer.push(data);
	}
};
